import React, { useRef, useState} from "react";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input, InputGroup, InputGroupAddon,
    Label,
    Row
} from "reactstrap";
import {ErrorMessage, useForm} from "react-hook-form";
import {connect, useSelector} from "react-redux";
import * as Yup from "yup";



// components
import {  GenericTableButton } from "../../../components/buttons/buttonsActions";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";

// labels
import {
     REQUIRED
} from "../../../components/i18n/i18n";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// actions

// components
// services & providers
import {userService} from "../../../jwt/_services";
import SelectSupervisor from "../../../components/select/selectSupervisor";
import Switch from "react-bootstrap-switch";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";
import UserRoleSection from "./UserRoleSection";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";

const UserForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { editMode, domainObject } = componentState?.data;

    // Banderas
    const [enabled, setEnabled] = useState( domainObject?.enabled !== undefined ? domainObject?.enabled : true);
    const [passwordExpired, setPasswordExpired] = useState(domainObject?.passwordExpired !== undefined ? domainObject?.passwordExpired : false);
    const [accountLocked, setAccountLocked] = useState(domainObject?.accountLocked !== undefined ? domainObject?.accountLocked : false);
    const [accountExpired, setAccountExpired] = useState(domainObject?.accountExpired !== undefined ? domainObject?.accountExpired : false);
    const [isPasswordShown, setIsPasswordShown] = useState(false);
    const [isSupervisor, setIsSupervisor] = useState(domainObject?.isSupervisor !== undefined ? domainObject?.isSupervisor : false);
    const [supervisor, setSupervisor] = useState(editMode ? props?.item?.supervisor?.id : null)
    const [checkTokenExpiration, setCheckTokenExpiration] = useState(editMode ? domainObject?.checkTokenExpiration : false);
    const [showHistoryModal, setShowHistoryModal] = useState(true);
    const modalHistoryRef = useRef(null);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalHistoryRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(REQUIRED),
        lastName: Yup.string().required(REQUIRED),
        username: Yup.string().required(REQUIRED),
        password: Yup.string().required(REQUIRED),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            name: domainObject?.name,
            lastName: domainObject?.lastName,
            username: domainObject?.username,
            password: domainObject?.password,
            employeeNumber: domainObject?.employeeNumber,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            ...data,
            enabled: enabled,
            passwordExpired: passwordExpired,
            accountLocked: accountLocked,
            accountExpired: accountExpired,
            isSupervisor:isSupervisor,
            checkTokenExpiration,
        };

        if(supervisor)
            dataRequest = { ...dataRequest, supervisor:{id:supervisor} }

        // console.log(dataRequest);
        // return;

        if (editMode) {
            let id = domainObject.id;
            dataRequest.id = id

            genericIndexedActions.update(path, userService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, userService, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }

    return (<>
            <Card className={editMode ? 'card-modal-medium-ex' : 'card-modal-small' }>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="far fa-edit mr-2"/>
                        <>
                            <h2 className={'card-modal-title'}> {(domainObject?.username || '') }</h2>
                            <br/>
                            <h5 className={'card-modal-uid'}> {(domainObject?.name || '') + ' ' + (domainObject?.lastName || '')}</h5>
                        </>
                        <div className={'top-right'}>
                            <GenericButton
                                style={'table'}
                                icon={'fa-save'}
                                toolTip={TT_SAVE}
                                permission={'add'}
                                type={'submit'}
                            />
                            {
                                editMode && <>
                                    <GenericTableButton
                                        toolTip={TT_HISTORY}
                                        icon={'fa-clock'}
                                        permission={'search'}
                                        onClick={showHistory}
                                    />
                                </>
                            }
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={closeForm}
                            />
                        </div>
                    </CardTitle>

                    <CardBody>
                        <Row>
                            <Col md={editMode ? "7" : "12"}>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Usuario</Label>
                                            <Input type="name" name="username"
                                                   placeholder="Usuario"
                                                   innerRef={register}
                                                   className={(errors.username ? ' is-invalid' : '')}
                                            />
                                            <ErrorMessage errors={errors} name="username" component="div"
                                                          className="invalid-feedback"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Contraseña</Label>
                                            <InputGroup>
                                                <Input name="password"
                                                       type={isPasswordShown ? "text" : "password"}
                                                       placeholder="Contraseña"
                                                       innerRef={register}
                                                       className={(errors.password ? ' is-invalid' : '')}
                                                />
                                                <InputGroupAddon addonType="append">
                                                    <Button color="secondary"
                                                            onClick={_ => setIsPasswordShown(!isPasswordShown)}>
                                                        {isPasswordShown ? <i className="fas fa-eye-slash"/> : <i className="fas fa-eye"/> }
                                                    </Button>
                                                </InputGroupAddon>
                                            </InputGroup>
                                            <ErrorMessage errors={errors} name="password" component="div" className="invalid-feedback"/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Nombre(s)</Label>
                                            <Input
                                                type="text"
                                                name="name"
                                                placeholder="Nombre(s)"
                                                innerRef={register}
                                                className={(errors.name ? ' is-invalid' : '')}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Apellidos</Label>
                                            <Input
                                                type="text"
                                                name="lastName"
                                                placeholder="Apellidos"
                                                innerRef={register}
                                                className={(errors.lastName ? ' is-invalid' : '')}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="9">
                                        <FormGroup>
                                            <Label>Correo electronico</Label>
                                            <Input
                                                type="text"
                                                name="email"
                                                placeholder="Correo electronico"
                                                innerRef={register}
                                                className={(errors.email ? ' is-invalid' : '')}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Número de colaborador</Label>
                                            <Input
                                                type="number"
                                                name="employeeNumber"
                                                placeholder="Número de colaborador"
                                                min="0"
                                                innerRef={register}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>¿Es supervidor?</Label>
                                            <br/>
                                            <Switch
                                                animate={true}
                                                offText={"No"}
                                                onText={"Si"}
                                                innerRef={register}
                                                onChange={()=> setIsSupervisor(!isSupervisor)}
                                                value={isSupervisor}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Supervisado por:</Label>
                                            <br/>
                                            <SelectSupervisor
                                                isDisabled={ isSupervisor }
                                                assignSupervisor={ setSupervisor }
                                                initialSupervisor={ supervisor }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>


                                <Row>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Activo</Label>
                                            <br/>
                                            <Switch animate={true} offText={"No"} onText={"Si"}
                                                    innerRef={register}
                                                    onChange={_ => setEnabled(!enabled)}
                                                    value={enabled}/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Contraseña expirada</Label>
                                            <br/>
                                            <Switch animate={true} offText={"No"} onText={"Si"}
                                                    innerRef={register}
                                                    onChange={_ => setPasswordExpired(!passwordExpired)}
                                                    value={passwordExpired}/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Cuenta expirada</Label>
                                            <br/>
                                            <Switch animate={true} offText={"No"} onText={"Si"}
                                                    innerRef={register}
                                                    onChange={_ => setAccountExpired(!accountExpired)}
                                                    value={accountExpired}/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Cuenta bloqueada</Label>
                                            <br/>
                                            <Switch animate={true} offText={"No"} onText={"Si"}
                                                    innerRef={register}
                                                    onChange={_ => setAccountLocked(!accountLocked)}
                                                    value={accountLocked}/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>¿Validar Token?</Label>
                                            <br/>
                                            <Switch animate={true}
                                                    offText={"No"}
                                                    onText={"Si"}
                                                    innerRef={register}
                                                    onChange={_ => setCheckTokenExpiration(!checkTokenExpiration)}
                                                    value={checkTokenExpiration}/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={"5"}>
                                {
                                    editMode && <UserRoleSection path={path}/>
                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Form>
            </Card>
            {
                showHistoryModal && <LogHistoryModal
                    ref={ modalHistoryRef }
                    item={ domainObject }
                />
            }
        </>
    )
}


const mapStateToProps = _ => ({
})

const mapActionsToProps = ({
    setItem,
    setForm,
    setTableParams,
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(UserForm)